import {
  ActivitySettings,
  DiagramGeneralSettings,
  FlowlineSettings,
  PositionType,
  ResourceSettings,
  RichTextSettings
} from '../diagram-type-styles.model';
import {UPN} from '../../../shared/constants/diagram-subtypes.constants';
import {IFlowlineJson} from '../../../diagram-data/diagram-json-handler.service';
import {DiagramBaseConfig} from './diagram-base-config';
import {FlowlineForm} from '../flowline-form.enum';

declare const mxGeometry: any;
declare const mxPoint: any;

export abstract class UPNBaseConfig extends DiagramBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      canAddToLegend: false,
      canAutoGenerateDrilldown: false,
      canAddAttribute: false,
      canGenerateStoriesAI: true,
      canGenerateRequirements: true,
      addSFAHeader: false,
      zoomToFitNeeded: false,
      isLabelMovable: true,
      tagColor: '#2A4D8D',
      allowedDrilldownSubtypes: []
    };
  }

  readonly activityShape = {w: 120, h: 80};

  activitySettings(x?: number, y?: number): ActivitySettings {
    const defaultActivityShape = this.activityShape;

    return {
      text: UPN.ACTIVITY_TEXT,
      position: this.getPosition(defaultActivityShape, x, y, PositionType.CENTER),
      dragHandlePosition: this.getPosition(defaultActivityShape, x, y, PositionType.DEFAULT),
      footerText: '',
      canPlaceFrontBack: false,
      canAddFooterText: false,
      canMakeContainerCard: false,
      selectedTabIndex: 3,
      defaultActivityShape,
      calcAddHeight: this.calculateAdditionalHeight,
      createActivityWithFlowline: false,
      template:
        '<input type="hidden" name="number" value="{{number}}"><!--contentbegin-->{{content}}<!--contentend-->'
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    const defaultFlowlineShape = {w: 70, h: 0};

    return {
      defaultGeoY: 15,
      dynamicLabel: '',
      canAddStartText: false,
      canAddEndText: false,
      canAddInteraction: false,
      defaultFlowlineShape,
      config: {
        text: UPN.FLOWLINE_TEXT,
        srcType: 'none',
        tgtType: 'activity',
        waypoints: null,
        srcPosition: {
          x: x - 70,
          y: y + 40
        },
        tgtPosition: {
          x: x + 70,
          y
        },
        position: {
          connectionPoints: {
            entryX: 0,
            entryY: 0.5
          },
          offset: {x: 0, y: 0},
          x: 0,
          y: 15
        },
        srcId: null,
        tgtId: Number(id)
      },
      geo: function (data?: IFlowlineJson) {
        if (!data?.position) {
          const geo = new mxGeometry(0, this.defaultGeoY);

          geo.relative = true;
          geo.offset = new mxPoint(0, 0);

          return geo;
        }

        const geo = new mxGeometry(Number(data.position.x), Number(data.position.y));

        geo.relative = true;
        geo.offset = new mxPoint(
          Number(data.position.offset?.x || 0),
          Number(data.position.offset?.y || 0)
        );

        return geo;
      },
      template: '<div class="flowline-content">{{content}}</div>',
      form: {
        shape: FlowlineForm.shape.Orthogonal,
        type: FlowlineForm.type.Solid,
        start: FlowlineForm.end.None,
        end: FlowlineForm.end.Classic
      }
    };
  }

  resourceSettings(resourceCount?: number): ResourceSettings {
    return {
      size: 24,
      height: resourceCount * 24,
      resourcePlacement: false
    };
  }

  get richTextSettings(): RichTextSettings {
    const defaultTextShape = {w: 120, h: 80};

    return {
      defaultTextShape,
      template:
        '<input type="hidden" name="number" value="{{number}}"><div class="text-shape-content">{{content}}</div>',
      preparePayload: ({x, y, number, style, position}) => ({
        number,
        position: this.getPosition(defaultTextShape, x, y, position),
        text: 'Text',
        customStyle: true,
        style,
        link: ''
      })
    };
  }
}
